<template>
    <v-container class="inputContainer">
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        <v-row justify="center">
            <v-col cols="auto">
                <div class="text-normal font-weight-bold" style="text-align: right; padding-top: 15px;">{{ contractRealDocument.filename }}</div>
            </v-col>
            <v-col cols="auto" style="max-width: 200px;">
                <v-select
                    v-model="scaleVal"
                    :items="scales"
                    outlined
                    @change="changeScale($event)"
                    background-color="white"
                ></v-select>
            </v-col>
            <v-col cols="12" l="2" lg="2" md="2" sm="2">
                <v-btn class="white--text" width="200" height="56" color="blue-grey" x-large offset-x @click="downloadPdf">
                    <v-icon left>mdi-cloud-download-outline</v-icon>ダウンロード
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="center">
            <pdf-preview-document-component
                v-for="(pdfObj, index) in Object.entries(this.pdfs)"
                :key="pdfObj[0]"
                v-show="currentPdfId==pdfObj[0]"
                scale="1"
                :pdfId="pdfObj[0]"
                :pdfData="pdfObj[1]['pdfData']"
                :destinations="destinations"
                :colorsIdMap="colorsIdMap"
                :bgColorsIdMap="bgColorsIdMap"
                :createUserId="createUserId"
                :registeredInputs="registeredInputs[pdfObj[0]]"
                :scaleStyles="scaleStyles"
                @loading="loading"
                ref="pdfDocumentPreview"
            />
        </v-row>
    </v-container>
</template>

<script>
    import { colorList, bgColorList, colorListIdMap } from '../../common/colorUtil.js';
    export default {
        props: ['contractRealDocument', 'destinations', 'pdfs', 'createUserId', 'registeredInputs'],
        data: function () {
            return {
                fileTab: 0,
                inputs: {},
                inputNum: 0,
                currentPdfId: 0,
                pdfLoading: false,
                pdfIdMap: {},
                colors: [],
                bgcolors: [],
                colorsIdMap: {},
                bgColorsIdMap: {},
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
                scaleStyles: {  // 拡大・縮小用スタイル
                    transform: "scale(1)",
                    'transform-origin': "top",
                },
                scales: [ // 拡大・縮小倍率
                    { text: '50%' , value: 'scale(0.5)' },
                    { text: '70%' , value: 'scale(0.7)' },
                    { text: '80%' , value: 'scale(0.8)' },
                    { text: '90%' , value: 'scale(0.9)' },
                    { text: '100%' , value: 'scale(1)' },
                    { text: '110%' , value: 'scale(1.1)' },
                    { text: '120%' , value: 'scale(1.2)' },
                    { text: '150%' , value: 'scale(1.5)' },
                    { text: '200%' , value: 'scale(2)' },
                ],
                scaleVal: 'scale(1)',
            };
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        created: function () {
             this.currentPdfId = this.contractRealDocument.id;
            Object.entries(this.pdfs).forEach((val, i) => {
                this.pdfIdMap[val[0]] = i;
            });
            this.colors = colorList;
            this.bgcolors = bgColorList;
            let ids = [];
            this.destinations.forEach(val => {
                ids.push(val.id);
            });
            // 契約送付先IDと色のマッピング作成
            this.colorsIdMap = colorListIdMap(ids, colorList);
            this.bgColorsIdMap = colorListIdMap(ids, bgColorList);
            this.inputs = Object.assign({}, this.registeredInputs);
        },
        methods: {
            changePdf: function (id) {
                this.currentPdfId = id;
            },
            loading: function (isLoading) {
                this.pdfLoading = isLoading;
            },
            downloadPdf: function () {
                let pdfObj = Object.entries(this.pdfs);
                
                let blob = this.toBlob(pdfObj[0][1]['pdfData']);
                if (blob) {
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    
                    link.download = pdfObj[0][1]['filename'];
                    link.click();
                    
                    window.axios.post('/documents/operation-log/save', {
                        display_name: 'テンプレートプレビュー',
                        operation: 'テンプレートダウンロード',
                        target: this.contractRealDocument.filename,
                        target_id: this.contractRealDocument.object_id,
                        supplement: pdfObj[0][1]['templateName'],
                        table_name: '契約書テンプレート実文書',
                        table_id: this.contractRealDocument.id
                    });
                }
                return false;
            },
            changeScale: function (e) {
                this.scaleStyles.transform = e;
                var xScale = Number(e.replace( /scale\(/g , "" ).replace( /\)/g , "" ));
                var appEle = document.getElementsByClassName("v-application")[0];
                if (xScale > 1) {
                    var diffHeight = (880 * xScale) - 880;
                    appEle.style.height = (appEle.scrollHeight + diffHeight) + "px";
                } else {
                    appEle.style.height = "auto";
                }
                // var container_w = (parseFloat(previewContainer.style.width) * Number(xScale));
                // var container_h = (parseFloat(previewContainer.style.height) * Number(xScale));
                // previewContainer.style.width = container_w + "px"
                // previewContainer.style.height = container_h + "px"

                // var canvas = document.getElementById( "pdf-preview" );
                // var canvas_w = canvas.width;
                // var canvas_h = canvas.height;
                // this.$refs.pdfDocumentPreview[0].setFieldStyle(canvas_w / Number(xScale), canvas_h / Number(xScale));
            },
            toBlob: function (base64) {
                var bin = window.atob(base64.replace(/^.*,/, ''));
                var buffer = new Uint8Array(bin.length);
                for (var i = 0; i < bin.length; i++) {
                    buffer[i] = bin.charCodeAt(i);
                }
                // Blobを作成
                try{
                    var blob = new window.Blob([buffer.buffer], {
                        type: 'application/pdf'
                    });
                }catch (e){
                    return false;
                }
                return blob;
            }
        }
    };
</script>

<style scoped>
</style>